import { GetListParams } from 'react-admin';
import {
  CustomDataProvider,
  registerModuleDataProvider,
} from '../../../providers/CustomDataProvider';
import {
  SweepHistoryFilters,
  listSweepHistory,
} from '../../../services/xbitRelaySweepService';

const resourceName = 'xbit-relay/sweep-history';

const pickFilter = (filter: any): SweepHistoryFilters => {
  if (!filter) return {};
  const out: SweepHistoryFilters = {};
  if (filter.userId) out.userId = filter.userId;
  if (filter.provider) out.provider = filter.provider;
  if (filter.address) out.address = filter.address;
  if (filter.chainId !== undefined && filter.chainId !== '' && filter.chainId !== null) {
    out.chainId = Number(filter.chainId);
  }
  return out;
};

export const xbitRelaySweepHistoryDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};

    const response = await listSweepHistory({
      ...pickFilter(filter),
      page,
      pageSize: perPage,
    });

    const { items = [], total } = response.data || ({} as any);
    return {
      data: items.map((item) => ({ ...item, id: item.id })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelaySweepHistoryDataProvider);
